import React, { useContext } from 'react';
import clsx from 'clsx';
import { getConfig } from '../util/config';
import Vh100Context from '../../forms/Vh100Context';

function MinHeightPage(props) {
    const { className, children, ...others } = props;
    const height = useContext(Vh100Context);

    let style = null;
    if (height) {
        style = { minHeight: height - 20 };
    }

    return (
        <div className={clsx(className, getConfig().pageClass)} {...others} style={style}>
            {children}
        </div>
    );
}

export default MinHeightPage;
